import React, { FC, useCallback } from 'react';
import { matchPath, NavLink, useLocation } from 'react-router-dom';
import cx from 'classnames';
import qs from 'query-string';

interface ILinkComponent {
  children: React.ReactNode;
  className?: string;
  link: string;
  target?: string;
}

export const LinkComponent: FC<ILinkComponent> = ({ children, className, link, target = '' }) => {
  const { pathname, search } = useLocation();
  const active = !!matchPath(pathname, { path: link });

  const parsedQuery = qs.parse(search);
  const isDetailPage = !!parsedQuery.e;
  const isResultDetailPage = !!parsedQuery.r;
  const isSearchPage = !!parsedQuery.q;
  const onClickHandler = useCallback(
    e => {
      if (active && !isDetailPage && !isSearchPage && !isResultDetailPage) {
        e.preventDefault();
      }
    },
    [active, isDetailPage, isSearchPage, isResultDetailPage],
  );

  if (link.startsWith('http')) {
    const linkClassName = cx(className, {
      active: link.includes(pathname),
    });

    return (
      <a className={linkClassName} href={link} onClick={onClickHandler} target={target}>
        {children}
      </a>
    );
  }

  return (
    <NavLink
      activeClassName="active"
      className={className}
      onClick={onClickHandler}
      target={target}
      to={link}
    >
      {children}
    </NavLink>
  );
};
